import {Component, 
    Input, 
    OnInit, 
    ChangeDetectionStrategy, 
    Inject, 
    PLATFORM_ID,
    ChangeDetectorRef} from "@angular/core";
import { VideoPlayer } from '../video-player/video-player.component';
import { HttpClient} from "@angular/common/http";
import { TimerObservable } from "rxjs/observable/TimerObservable";
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common';


@Component({
    selector: "stream-row",
    templateUrl: "./stream-row.template.html",
    styleUrls: ["./stream-row.style.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class StreamRow{
    @Input() row : any;
    private ngUnsubscribe:Subject<any> = new Subject<any>();;
    public data: Observable<Object>;
    private previousSlug: string = '';
    private isServer = false;
    public super:any = {title: '', summary: ''};

    constructor(private http: HttpClient, 
        @Inject(PLATFORM_ID) platformId: string,
        private cd: ChangeDetectorRef){
        this.isServer = isPlatformServer(platformId);
    }

    ngOnInit(){
        this.data = this.http.get(this.row.meta.section.title);
        
        if(!this.isServer)
            this.fetchData();
    }

    fetchData(){
        TimerObservable.create(0, 4000)
        .takeUntil(this.ngUnsubscribe)
        .subscribe(() => {
            this.data.subscribe( data => {
                const meta:any = data["meta"];
                if(this.previousSlug != meta.slug)
                {
                    this.previousSlug = meta.slug;
                    this.super.title = meta.title;
                    this.super.summary = meta.summary;
                    this.cd.detectChanges();
                }
            });
        });
    }

    ngOnDestroy() {
        if(this.ngUnsubscribe)
        {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
            this.ngUnsubscribe.unsubscribe();
        }
    }
}




// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/stream-row/stream-row.component.ts